import { useState } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

export const useSubtitles = () => {
    const instance = usePlayerInstance();
    const [subtitles, setSubtitles] = useState<string[] | undefined>(
        () => instance?.currentSubtitles
    );

    useInstanceEffect((instance) => {
        const onSubtitleChanges = () => setSubtitles(instance.currentSubtitles);

        const unsubscribeFromSubtitleListener =
            instance.onCurrentSubtitlesChange(onSubtitleChanges);
        const unsubscribeFromTextTrackListener =
            instance.onCurrentTextTrackChange(onSubtitleChanges);

        return () => {
            unsubscribeFromSubtitleListener();
            unsubscribeFromTextTrackListener();
        };
    }, []);

    return subtitles;
};
